import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import {
  Collapse} from '@material-ui/core';
import { 
  Modal,
  Button,
  Icon,
} from  'semantic-ui-react'

const K2ErrorModal = (props) => {
  const {
    checkK2Error,
  } = props

  const [show,setShow] = React.useState(true)
  const [showMore,setShowMore] = React.useState(false)

  
  return (
    <div style={{display:'flex'}}>
      {checkK2Error.isError&&
        <Button size='mini' color='red' icon labelPosition='left' onClick={()=>setShow(true)}>
          <Icon name='close' />
          View K2Error
        </Button>
      }
      <Modal open={checkK2Error.isError&&show} size='tiny'>
        <Modal.Header>Systems Message</Modal.Header>
        <Modal.Content>
          <div style={{display:'flex',flexDirection:'column'}}>
            <div>
              K2 error please contact Admin
            </div>
            <div style={{marginTop:'1rem'}}>
              <a onClick={()=>setShowMore(!showMore)}>Error message...</a>
              <Collapse in={showMore}>
                <div style={{marginLeft:'1rem',color:'red',whiteSpace: 'pre-wrap'}}>{checkK2Error.msg}</div>
              </Collapse> 
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button color='yellow' onClick={()=>setShow(!show)}>
            <Icon name='remove' /> Close
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  
})
const mapDispatchToProps = {
  
}

export default connect(mapStateToProps, mapDispatchToProps)(K2ErrorModal)
